import React from "react";
import GenerateReports from "../../components/GenerateReports/GenerateReports";
import MysavedReports from "../../components/MySavedReports/MySavedReports";
import ReportCustomization from "../../components/ReportCustomization/ReportCustomization";
import "./Reports.css";

const Reports = () => {
    return (
        <div className="reports-container">
            <div className="top-container">
                <GenerateReports />
                <MysavedReports />
            </div>
            <ReportCustomization />
        </div>
    );
};

export default Reports;
